import type { Jurisprudence } from "../models";
import { apiInstance } from "../utils/_apiInstance";

interface GetJurisprudenceResponse {
  modo: string;
  resultado: Jurisprudence;
}

export const getJurisprudenceById = async (id: string) => {
  const response = await apiInstance.get<GetJurisprudenceResponse>(
    `pesquisa/jurisprudencia?ementa=${id}`,
  );
  return response.data.resultado;
};
